<template>
    <div>
        <div class="card-header">{{title}}</div>
        <div class="card-body">
            <form @submit.prevent="saveSetting1">
                <div class="form-group row">
                    <div class="input-group col-12"><p>Invoice & Estimate:&nbsp;&nbsp;<small>(Product Description)</small> </p></div>
                    <div class="input-group mb-3 col-6">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1">Numer Of Words: </span>
                        </div>
                        <input type="number" class="form-control" v-model="description" placeholder="Example: 220" required id="NumberWordsProDes" aria-describedby="NumberWordsProDes" maxlength="3"  minlength="2" min="50" max="500"/>
                        <div class="input-group-prepend">
                            <button type="submit" class="btn btn-success">SAVE</button>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="alert alert-info" role="alert">
                        <p>
                            <strong>Info: </strong>
                            <br>This setting is used to set the number of words for the product description field.
                            <br> Numeric value only.
                            <br> It has a minimum range of 50 and a maximum of 500 words.
                        </p>
                    </div>
                </div>
            </form>
            <hr>
            <form @submit.prevent="saveSetting2">
                <div class="form-group row">
                    <div class="input-group col-12"><p>Job information:&nbsp;&nbsp;</p></div>
                    <div class="input-group mb-3 col-6">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1">Numer Of Words: </span>
                        </div>
                        <input type="number" class="form-control" v-model="job_information" placeholder="Example: 50" required id="NumberWordsProDes" aria-describedby="NumberWordsProDes" maxlength="3"  minlength="2" min="20" max="100"/>
                        <div class="input-group-prepend">
                            <button type="submit" class="btn btn-success">SAVE</button>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="alert alert-info" role="alert">
                        <p>
                            <strong>Info: </strong>
                            <br>This setting is used to set the number of words for the job information field.
                            <br> It has a minimum range of 20 and a maximum of 100 words.
                        </p>
                    </div>
                </div>
            </form>
            <hr>
            <form @submit.prevent="saveSetting3">
                <div class="form-group row">
                    <div class="input-group col-12"><p>Customer Message:&nbsp;&nbsp;</p></div>
                    <div class="input-group mb-3 col-6">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1">Numer Of Words: </span>
                        </div>
                        <input type="number" class="form-control" v-model="customer_message" placeholder="Example: 50" required id="NumberWordsProDes" aria-describedby="NumberWordsProDes" maxlength="3"  minlength="2" min="20" max="100"/>
                        <div class="input-group-prepend">
                            <button type="submit" class="btn btn-success">SAVE</button>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="alert alert-info" role="alert">
                        <p>
                            <strong>Info: </strong>
                            <br>This setting is used to set the number of words for the Customer Message field.
                            <br> It has a minimum range of 20 and a maximum of 100 words.
                        </p>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    name: 'numberWordsProDes',
    components: {
    },
    data () {
        return {
            isLoading: false,
            showMenu: 0,
            title: '',
            meta_key: '',
            description: '220',
            job_information: '50',
            customer_message: '50',
        };
    },
    created () {
        let t = this;
        let getModal = t.$store.getters['core/getOpenModal'];
        t.title = getModal.data.title;
        t.getWords('numberWordsProDes', this.description);
        t.getWords('job_information_numberWords', this.job_information);
        t.getWords('customer_message_numberWords', this.customer_message);
    },
    methods: {
        getWords (meta_key, meta_value) {
            this.isLoading = true;
            this.$store.commit("core/setLoadingModal", true);
            window.billing
                .post('getKeyValSetting', {
                    user_id: window.master_client,
                    org_id: window.localorgdata,
                    meta_key: meta_key,
                })
                .then((response) => {
                    console.log(response.data);
                    try{
                            meta_value = response.data.status ? response?.data?.r?.meta_value : 220;
                            meta_value = parseInt(meta_value);
                    }catch(e){
                        meta_value = 220;
                    }
                    this.isLoading = false;
                    this.$store.commit("core/setLoadingModal", false);
                })
                .catch((error) => {
                    console.log(error);
                    this.$store.commit("core/setLoadingModal", false);
                });
        },
        saveSetting1 () {
            this.$store.commit("core/setLoadingModal", true);
            window.billing
                .post('setAnyKeyValSetting', {
                    user_id: window.master_client,
                    org_id: window.localorgdata,
                    meta_key: 'numberWordsProDes',
                    meta_value: this.description, //numberWordsProDes
                })
                .then((response) => {
                    this.$store.commit('ModApps/billing/setNumberWordsProDes', this.description);
                    this.$store.commit("core/setLoadingModal", false);
                    this.$store.commit("core/setCloseModal", {action: 'saved'});
                })
                .catch((error) => {
                    this.$store.commit("core/setLoadingModal", false);
                    console.log(error);
                    this.isLoading = false;
                });
        },
        saveSetting2 () {
            this.$store.commit("core/setLoadingModal", true);
            window.billing
                .post('setAnyKeyValSetting', {
                    user_id: window.master_client,
                    org_id: window.localorgdata,
                    meta_key: 'job_information_numberWords',
                    meta_value: this.job_information, //numberWordsProDes
                })
                .then((response) => {
                    this.$store.commit("core/setLoadingModal", false);
                    this.$store.commit("core/setCloseModal", {action: 'saved'});
                })
                .catch((error) => {
                    this.$store.commit("core/setLoadingModal", false);
                    console.log(error);
                    this.isLoading = false;
                });
        },
        saveSetting3 () {
            this.$store.commit("core/setLoadingModal", true);
            window.billing
                .post('setAnyKeyValSetting', {
                    user_id: window.master_client,
                    org_id: window.localorgdata,
                    meta_key: 'customer_message_numberWords',
                    meta_value: this.customer_message, //numberWordsProDes
                })
                .then((response) => {
                    this.$store.commit("core/setLoadingModal", false);
                    this.$store.commit("core/setCloseModal", {action: 'saved'});
                })
                .catch((error) => {
                    this.$store.commit("core/setLoadingModal", false);
                    console.log(error);
                    this.isLoading = false;
                });
        },
    },
    computed: { },
};
</script>
